import { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Button, Card, Figure, Spinner } from "react-bootstrap"
import { FiUpload, FiEye } from 'react-icons/fi'
import { BsFileEarmarkRichtext } from "react-icons/bs"
import { GoTrash } from "react-icons/go"
import { IoMdAdd } from "react-icons/io"
import Multiselect from 'multiselect-react-dropdown';
import AzioniSondaggio from "./AzioniSondaggio";
import SezioneSondaggio from "./SezioneSondaggio";
import SondaggioService from "../../../services/SondaggiService"
import ModalConferma from "../../Utilities/ModalConferma";
import { statiSondaggio } from "../../Utilities/statiElementEnum";
import { max_dimensione_banner_sondaggi } from "../../Utilities/variables";
import ModalIntervalliPunteggio from './ModalIntervalliPunteggio';
import IntervalloPunteggioService from "../../../services/IntervalloPunteggioService";
import { DragDropContext } from 'react-beautiful-dnd';


const dayjs = require('dayjs');
const customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)

const DRAFT_KEY_NEW_SONDAGGIO = "bozza_sondaggio_nuovo_gestisci"; // Specific key


/*
PROPS PASSATE
<GestisciSondaggio
comune={props.comune}
sonId={sonId}
setMostraTabella={props.setMostraTabella}
gestisci={gestisci}
setGestisci={setGestisci}
setDirty={setDirty}
 dirty={dirty}
/>

gestisci qui può essere arrivato perchè
1) aggiungi-sondaggio //bottone Nuovo
2) controlla-sondaggio //azione sulla tabella controlla
*/

export default function GestisciSondaggio(props) {

    /*useEffect(() => {
  const bozza = localStorage.getItem("bozza_sondaggio");
  if (bozza) {
    setForm(JSON.parse(bozza));
  }
}, []);*/


    const [erroreValidazioneForm, setErroreValidazioneForm] = useState(false);
    const [mostraSoloLetturaIntervalli, setMostraSoloLetturaIntervalli] = useState(false);
    const [scrollToSectionPos, setScrollToSectionPos] = useState(null); // Stato per memorizzare la posizione a cui scorrere
    const [domandaToDeleteIndices, setDomandaToDeleteIndices] = useState({ secIdx: null, domIdx: null }); // Salva gli indici della domanda da eliminare
    const [mostraModaleIntervalli, setMostraModaleIntervalli] = useState(false);
    const [intervalliPunteggio, setIntervalliPunteggio] = useState([]);
    const [punteggioRange, setPunteggioRange] = useState({ punteggioMin: 0, punteggioMax: 0 });
    const [azionePending, setAzionePending] = useState(null);
    const [mostraConfermaDopoIntervalli, setMostraConfermaDopoIntervalli] = useState(false);
    //stati per le domande
    const [mostraModaleDeleteDomanda, setMostraModaleDeleteDomanda] = useState(false)
    const [domandaToDelete, setDomandaToDelete] = useState(null)
    //array di domande da eliminare
    let [domandeToDelete, setDomandeToDelete] = useState([])

    // Valore che permette l'inizializzazione una volta sola al caricamento della pagina
    let [init, setInit] = useState(true)

    // stati che possono essere modificati per la gestione del bilancio
    let [sonStato, setSonStato] = useState("")
    let [sonId, setSonId] = useState("")

    // FINESTRE MODALI
    const [mostraModaleOperazione, setMostraModaleOperazione] = useState(false)
    const [mostraModaleSuccesso, setMostraModaleSuccesso] = useState(false)
    const [mostraModaleErrore, setMostraModaleErrore] = useState(false)
    const [parolaChiave, setParolaChiave] = useState("")
    const [titolo, setTitolo] = useState("")
    const [messaggio, setMessaggio] = useState("")

    const [mostraModaleDeleteSezione, setMostraModaleDeleteSezione] = useState(false);

    //campi modificabili a seconda delle richieste
    let permettiDataInizioSondaggioPrecedenteDataInizioDb = true
    let permettiDataInizioPrimaDiOggi = false

    let select = useRef(null)

    const [validato, setValidato] = useState(false)
    const [errori, setErrori] = useState({})

    // Stato per passare gli intervalli CORRENTI al modal quando viene aperto
    const [intervalliPerModal, setIntervalliPerModal] = useState([]);

    //se props.gestisci = controlla-sondaggio metti caricando a true, cosi si riprende il sondaggio tramite l'id passato nelle props
    const [caricandoSondaggio, setCaricandoSondaggio] = useState(
        props.sonId !== null ? true : false
    );


    const [sezioneToDelete, setSezioneToDelete] = useState(null);



    /*
         * La data inizio viene duplicata nella variabile dataInizioCurrent per evitare che in fase
         * di modifica di un bilancio esistente si possa inserire una data di inizio
         * inferiore a quella memorizzata in db
        */
    let dataInizioCurrent = null
    const oraProssima = (() => {
        const oraAttuale = dayjs().hour();
        return ((oraAttuale + 2) % 24).toString().padStart(2, '0');
    })();




    //Validazione del form
    const [form, setForm] = useState({
        sonTitolo: "",
        sonDataInizio: dayjs().format('YYYY-MM-DD'),
        sonOraInizio: oraProssima,  // Inserisce due ore dopo  a quella corrente
        sonDataChiusura: dayjs().add(2, 'M').format('YYYY-MM-DD'),
        sonOraChiusura: "23",  // Nuovo campo
        sonTipoPunteggio: false,
        sonDescrizione: "",
        sonSezioni: [
            {
                sezNome: "Sezione 1",
                sezPosizione: 1,
                domande: [
                    {
                        domDomanda: "", // Testo della domanda
                        tipDomId: null, // Tipo domanda
                        domNumPosizione: 1, // Ordine domanda
                        domTabellaPredefinita: false,
                        domObbligatoria: false,
                        opzioniRisposta: [ // Array di opzioni di risposta
                            {
                                opzRisTesto: "", // Testo dell'opzione
                                opzRisPunteggio: null, // Punteggio assegnato
                                opzRisPosizione: 1,
                                opzRisSezSuccessiva: null, // Sezione successiva (per logica condizionale)
                                opzRisFlTermina: false // Se la risposta termina il sondaggio
                            }
                        ]
                    }
                ]
            }
        ]
    });


    //Stati per il banner file
    let inputFile = useRef(null)
    const [file, setFile] = useState();
    const [uploadedFilesMetadata, setUploadedFilesMetadata] = useState([]);
    const acceptedExtensions = ["image/*", "image/png", "image/jpg", "image/jpeg"]
    const [erroreAllegati, setErroreAllegati] = useState("")

    //opzioni delle categorie
    const [options, setOptions] = useState([])
    const [selectedOptions, setSelectedOptions] = useState([])

    //stato categoriaValidata per determinare se il campo è stato validato almeno una volta:
    const [categoriaValidata, setCategoriaValidata] = useState(false);

    const [sezioniToDelete, setSezioniToDelete] = useState([]);



    const [punteggi, setPunteggi] = useState(false)

    /*useEffect(() => {
  localStorage.setItem("bozza_sondaggio", JSON.stringify(form));
}, [form]);*/




    //Quando viene creato il sondaggio se ci sono errori al salva funzione controlla qual'è il primo errore presente e riporta scrollando a quell'errore
    const scrollToFirstError = (errors) => {
        let firstErrorElementId = null;
        // Check top-level errors first (in validation order)
        if (errors.sonTitolo) {
            firstErrorElementId = "sondaggio-titolo-group";
        } else if (errors.sonDataInizio || errors.sonOraInizio || errors.sonDataChiusura || errors.sonOraChiusura) {
            firstErrorElementId = "sondaggio-date-group";
        } else if (errors.sonDescrizione) {
            firstErrorElementId = "sondaggio-descrizione-group";
        } else if (errors.sonCategorie) {
            firstErrorElementId = "sondaggio-categorie-group";
        } else if (errors.erroriDomande) {
            for (let secIdx = 0; secIdx < errors.erroriDomande.length; secIdx++) {
                const sezioneErrori = errors.erroriDomande[secIdx] || [];
                for (let domIdx = 0; domIdx < sezioneErrori.length; domIdx++) {
                    const domandaErrori = sezioneErrori[domIdx] || {};
                    // Controlla se l'oggetto errore per questa domanda non è vuoto
                    if (Object.keys(domandaErrori).length > 0) {
                        firstErrorElementId = `domanda-${secIdx}-${domIdx}`;
                        break; //trovato il primo errore su una domanda, stoppa il loop interno 
                    }
                }
                if (firstErrorElementId) {
                    break; //trovato il primo errore domanda, stoppa il loop
                }
            }
        }

        // Se è stato trovato un errore su in elementID, scrolla  a quell'errore
        if (firstErrorElementId) {
            const element = document.getElementById(firstErrorElementId);
            if (element) {
                element.scrollIntoView({
                    behavior: "smooth",
                    block: "center", // Align top of element with center of viewport (or 'top')
                    inline: "nearest"
                });
            } else {
                console.warn(`Element with ID '${firstErrorElementId}' not found for scrolling.`);
            }
        }
    };


    const generaCombinazioni = (opzioni, min, max) => {
        const results = [];

        const backtrack = (start, path) => {
            if (path.length >= min && path.length <= max) {
                results.push([...path]);
            }
            if (path.length === max) return;

            for (let i = start; i < opzioni.length; i++) {
                path.push(opzioni[i]);
                backtrack(i + 1, path);
                path.pop();
            }
        };

        backtrack(0, []);
        return results.length > 0 ? results : [[]]; // ritorna almeno una vuota se nessuna valida
    };

    const calcolaPunteggioMassimoDinamico = () => {
        const sezioniMap = new Map();
        form.sonSezioni.forEach(sez => {
            sezioniMap.set(sez.sezPosizione, sez);
        });

        const esplora = (pos, visited = new Set()) => {
            if (visited.has(pos)) return 0;
            const sezione = sezioniMap.get(pos);
            if (!sezione) return 0;
            visited.add(pos);

            const punteggiPercorsi = [];

            const combinaDomande = (indiceDomanda, punteggioParziale, sezioniVisitate) => {
                if (indiceDomanda >= sezione.domande.length) {
                    // Dopo tutte le domande, vai alla prossima sezione (se non terminato)
                    const nextPos = pos + 1;
                    if (sezioniMap.has(nextPos)) {
                        const nuovoSet = new Set(sezioniVisitate);
                        const punteggioTot = punteggioParziale + esplora(nextPos, nuovoSet);
                        punteggiPercorsi.push(punteggioTot);
                    } else {
                        punteggiPercorsi.push(punteggioParziale);
                    }
                    return;
                }

                const domanda = sezione.domande[indiceDomanda];
                const opzioni = domanda.opzioniRisposta || [];
                const isMultipla = domanda.tipDomMultipla;
                const min = isMultipla ? (domanda.tipDomMinRisposte ?? 0) : 1;
                const max = isMultipla ? (domanda.tipDomMaxRisposte ?? opzioni.length) : 1;
                const combinazioni = generaCombinazioni(opzioni, min, max);

                for (const combo of combinazioni) {
                    let punteggioCombo = combo.reduce((acc, o) => acc + (o.opzRisPunteggio || 0), 0);
                    const termina = combo.some(o => o.opzRisFlTermina);
                    const sezSalto = combo.find(o => o.opzRisSezSuccessiva);

                    if (termina) {
                        punteggiPercorsi.push(punteggioParziale + punteggioCombo);
                        continue;
                    }

                    if (sezSalto) {
                        const next = parseInt(sezSalto.opzRisSezSuccessiva);
                        const nuovoSet = new Set(sezioniVisitate);
                        const punteggioTot = punteggioParziale + punteggioCombo + esplora(next, nuovoSet);
                        punteggiPercorsi.push(punteggioTot);
                        continue;
                    }

                    // Nessun salto → prosegui con la prossima domanda
                    combinaDomande(indiceDomanda + 1, punteggioParziale + punteggioCombo, sezioniVisitate);
                }
            };

            combinaDomande(0, 0, visited);
            return punteggiPercorsi.length > 0 ? Math.max(...punteggiPercorsi) : 0;
        };

        return esplora(1);
    };



    const calcolaPunteggioMinimoDinamico = () => {
        const mappaSezioni = new Map();
        form.sonSezioni.forEach(sez => {
            mappaSezioni.set(sez.sezPosizione, sez);
        });

        const esplora = (posSezione, visited = new Set()) => {
            if (visited.has(posSezione)) return 0;
            visited.add(posSezione);

            const sezione = mappaSezioni.get(posSezione);
            if (!sezione) return 0;

            const esploraDomande = (indiceDomanda, percorsoPunteggio, visitati) => {
                if (indiceDomanda >= sezione.domande.length) {
                    return percorsoPunteggio;
                }

                const domanda = sezione.domande[indiceDomanda];
                const opzioni = domanda.opzioniRisposta || [];

                const isMultipla = domanda.tipDomMultipla;
                const min = isMultipla
                    ? (domanda.tipDomMinRisposte ?? (domanda.domObbligatoria ? 1 : 0))
                    : (domanda.domObbligatoria ? 1 : 0);
                const max = isMultipla ? (domanda.tipDomMaxRisposte ?? opzioni.length) : 1;

                const combinazioni = generaCombinazioni(opzioni, min, max);

                let minPunteggio = Infinity;

                for (const combo of combinazioni) {
                    const sommaPuntiCombo = combo.reduce((sum, opz) => sum + (opz.opzRisPunteggio || 0), 0);
                    const termina = combo.some(opz => opz.opzRisFlTermina);
                    const sezSuccessiva = combo.find(opz => opz.opzRisSezSuccessiva)?.opzRisSezSuccessiva;
                    const sezSuccessivaInt = parseInt(sezSuccessiva);

                    if (!termina && !isNaN(sezSuccessivaInt) && mappaSezioni.has(sezSuccessivaInt)) {
                        const punteggioDopo = esplora(sezSuccessivaInt, new Set(visitati));
                        minPunteggio = Math.min(minPunteggio, percorsoPunteggio + sommaPuntiCombo + punteggioDopo);
                    } else {
                        const punteggioDopo = esploraDomande(indiceDomanda + 1, percorsoPunteggio + sommaPuntiCombo, visitati);
                        minPunteggio = Math.min(minPunteggio, punteggioDopo);
                    }
                }

                return isFinite(minPunteggio) ? minPunteggio : percorsoPunteggio;
            };

            return esploraDomande(0, 0, visited);
        };

        return esplora(1);
    };

    const calcolaPunteggioTotale = () => {
        return {
            punteggioMin: calcolaPunteggioMinimoDinamico(),
            punteggioMax: calcolaPunteggioMassimoDinamico(),
        };
    };




    const duplicaSezione = (sezioneDaDuplicare) => {
        const index = form.sonSezioni.findIndex(s => s === sezioneDaDuplicare);
        if (index === -1) return;

        const nuovaSezione = {
            ...structuredClone(sezioneDaDuplicare),
            sezId: null, // rimuovi ID
            sezNome: `${sezioneDaDuplicare.sezNome} (Copia)`,
            domande: sezioneDaDuplicare.domande.map((domanda, domIndex) => ({
                ...structuredClone(domanda),
                domId: null,
                domNumPosizione: domIndex + 1,
                opzioniRisposta: domanda.opzioniRisposta.map((opz, opzIndex) => ({
                    ...structuredClone(opz),
                    opzRisId: null,
                    opzRisPosizione: opzIndex + 1
                }))
            }))
        };

        const nuoveSezioni = [...form.sonSezioni];
        nuoveSezioni.splice(index + 1, 0, nuovaSezione);

        // Ricalcola le posizioni
        nuoveSezioni.forEach((s, idx) => s.sezPosizione = idx + 1);

        setForm({ ...form, sonSezioni: nuoveSezioni });

        // Usa la posizione CALCOLATA dopo il riordino.
        // La nuova sezione si trova all'indice `index + 1` nel nuovo array `nuoveSezioni`.
        const posizioneFinaleNuovaSezione = nuoveSezioni[index + 1].sezPosizione;
        setScrollToSectionPos(posizioneFinaleNuovaSezione);
    };

    // useEffect per scorrere alla nuova sezione duplicata
    useEffect(() => {
        if (scrollToSectionPos !== null) {
            // Costruisci l'ID dell'elemento a cui scorrere
            const elementId = `sezione-${scrollToSectionPos}`;
            const element = document.getElementById(elementId);

            if (element) {
                // Scorre l'elemento nella vista
                element.scrollIntoView({
                    behavior: 'smooth', // Animazione fluida
                    block: 'start'      // Allinea l'inizio dell'elemento con l'inizio del viewport
                });
            }

            // Resetta lo stato dopo lo scroll per evitare scroll ripetuti
            setScrollToSectionPos(null);
        }
    }, [scrollToSectionPos]); // Esegui solo quando scrollToSectionPos cambia

    const tuttiPunteggiSonoZero = () => {
        return form.sonSezioni.every(sez =>
            sez.domande.every(dom =>
                (dom.opzioniRisposta || []).every(opz =>
                    !opz.opzRisPunteggio || opz.opzRisPunteggio === 0
                )
            )
        );
    };

    const handleDeleteDomandaRequest = (secIdx, domIdx) => {
        setDomandaToDeleteIndices({ secIdx, domIdx }); // Salva gli indici
        setMostraModaleDeleteDomanda(true);          // Apri il modale
    };

    // Questa funzione viene chiamata DOPO la conferma nel modale
    const confermaEliminazioneDomanda = () => {
        const { secIdx, domIdx } = domandaToDeleteIndices; // Recupera gli indici salvati

        // Controllo di sicurezza (se gli indici non sono validi)
        if (secIdx === null || domIdx === null) {
            console.error("Indici domanda da eliminare non validi");
            setMostraModaleDeleteDomanda(false); // Chiudi comunque il modale
            return;
        }

        setMostraModaleDeleteDomanda(false); // Chiudi il modale

        setForm((prevForm) => {
            const nuoveSezioni = [...prevForm.sonSezioni]; // Copia array sezioni

            // Controllo aggiuntivo che la sezione e la domanda esistano
            if (!nuoveSezioni[secIdx] || !nuoveSezioni[secIdx].domande[domIdx]) {
                console.error("Sezione o domanda non trovata per l'eliminazione");
                return prevForm; // Ritorna lo stato precedente se qualcosa non va
            }

            const domandaEliminata = nuoveSezioni[secIdx].domande[domIdx]; // Prendi riferimento PRIMA di eliminare

            // Aggiungi alla lista di domande da eliminare nel DB (SOLO se ha un ID)
            if (props.gestisci === "controlla-sondaggio" && domandaEliminata?.domId) {
                setDomandeToDelete((prev) => [...prev, domandaEliminata.domId]);
            }

            // Rimuovila dalla lista nello stato del form
            nuoveSezioni[secIdx].domande.splice(domIdx, 1);

            // Aggiorna le posizioni delle domande rimanenti nella sezione
            nuoveSezioni[secIdx].domande = nuoveSezioni[secIdx].domande.map((dom, i) => ({
                ...dom,
                domNumPosizione: i + 1
            }));

            return {
                ...prevForm,
                sonSezioni: nuoveSezioni // Ritorna il nuovo stato del form
            };
        });

        // Resetta gli indici salvati
        setDomandaToDeleteIndices({ secIdx: null, domIdx: null });
    };

    const handleDeleteSezione = (sezione) => {
        setSezioneToDelete(sezione);
        setMostraModaleDeleteSezione(true);
    };

    const deleteSezione = (sezione) => {
        setMostraModaleDeleteSezione(false);

        setForm((prevForm) => {
            const nuoveSezioni = prevForm.sonSezioni
                .filter(s => s !== sezione)
                .map((s, idx) => ({
                    ...s,
                    sezPosizione: idx + 1 // riordina le posizioni
                }));

            // Se la sezione ha un ID (quindi già salvata), la mettiamo nella lista da eliminare
            if (props.gestisci === "controlla-sondaggio" && sezione.sezId) {
                setSezioniToDelete((prev) => [...prev, sezione.sezId]);
            }

            return {
                ...prevForm,
                sonSezioni: nuoveSezioni
            };
        });
    };


    const handleDragEnd = (result) => {
        const { source, destination, draggableId } = result;
        if (!destination) return;

        // Sezione di origine e destinazione
        const fromSezIdx = form.sonSezioni.findIndex(s => `sezione-${s.sezPosizione}` === source.droppableId);
        const toSezIdx = form.sonSezioni.findIndex(s => `sezione-${s.sezPosizione}` === destination.droppableId);
        if (fromSezIdx === -1 || toSezIdx === -1) return;

        const nuoveSezioni = [...form.sonSezioni];

        // Rimuovi dalla sezione di origine
        const [moved] = nuoveSezioni[fromSezIdx].domande.splice(source.index, 1);

        // Inserisci nella sezione di destinazione
        nuoveSezioni[toSezIdx].domande.splice(destination.index, 0, moved);

        // Riassegna le posizioni in entrambe le sezioni
        nuoveSezioni[fromSezIdx].domande.forEach((d, i) => d.domNumPosizione = i + 1);
        nuoveSezioni[toSezIdx].domande.forEach((d, i) => d.domNumPosizione = i + 1);

        // Aggiorna `sezId` nella domanda se le sezioni sono diverse
        if (fromSezIdx !== toSezIdx) {
            moved.sezId = nuoveSezioni[toSezIdx].sezId || nuoveSezioni[toSezIdx].sezPosizione;
        }

        setForm({ ...form, sonSezioni: nuoveSezioni });
    };


    const handleOptionFieldChange = (sectionIndex, questionIndex, optionIndex, field, value) => {

        // 1. Update form state (immutable update)
        setForm(prevForm => {
            const nuoveSezioni = prevForm.sonSezioni.map((sezione, sIndex) => {
                if (sIndex !== sectionIndex) return sezione;
                const nuoveDomande = sezione.domande.map((domanda, qIndex) => {
                    if (qIndex !== questionIndex) return domanda;
                    const nuoveOpzioni = (domanda.opzioniRisposta || []).map((opzione, oIndex) => {
                        if (oIndex !== optionIndex) return opzione;
                        return { ...opzione, [field]: value };
                    });
                    return { ...domanda, opzioniRisposta: nuoveOpzioni };
                });
                return { ...sezione, domande: nuoveDomande };
            });
            return { ...prevForm, sonSezioni: nuoveSezioni };
        });


        // 2. Clear errors based on the *intended* new state
        setErrori(prevErrori => {
            // Deep clone necessary parts or the whole thing
            const nuoviErrori = JSON.parse(JSON.stringify(prevErrori));

            let errorCleared = false; // Flag to see if we actually cleared anything

            // --- Clear specific field error (e.g., opzRisTesto) ---
            if (nuoviErrori.erroriDomande?.[sectionIndex]?.[questionIndex]?.opzioniRisposta?.[optionIndex]?.[field]) {
                delete nuoviErrori.erroriDomande[sectionIndex][questionIndex].opzioniRisposta[optionIndex][field];
                errorCleared = true;
            }

            // --- Clear general question 'opzioni' error if applicable ---
            const updatedOptions = form.sonSezioni[sectionIndex].domande[questionIndex].opzioniRisposta.map((opz, idx) =>
                idx === optionIndex ? { ...opz, [field]: value } : opz // Simulate the update
            );
            const almenoUnaValida = updatedOptions.some(opz => opz.opzRisTesto && opz.opzRisTesto.trim() !== "");

            if (almenoUnaValida && nuoviErrori.erroriDomande?.[sectionIndex]?.[questionIndex]?.opzioni) {
                delete nuoviErrori.erroriDomande[sectionIndex][questionIndex].opzioni;
                errorCleared = true;
            }

            // Only return new state if something actually changed
            return errorCleared ? nuoviErrori : prevErrori;
        });
    };
    const aggiungiSezione = () => {
        const nuovaSezione = {
            sezNome: `Sezione ${form.sonSezioni.length + 1}`,
            sezPosizione: form.sonSezioni.length + 1,
            domande: [
                {
                    domDomanda: "",
                    tipDomMultipla: false,
                    tipDomMinRisposte: null,
                    tipDomMaxRisposte: null,
                    domNumPosizione: 1,
                    domTabellaPredefinita: false,
                    domObbligatoria: false,
                    opzioniRisposta: [
                        {
                            opzRisTesto: "",
                            opzRisPunteggio: null,
                            opzRisPosizione: 1,
                            opzRisSezSuccessiva: null,
                            opzRisFlTermina: false
                        }
                    ]
                }
            ]
        };

        setForm(prev => ({
            ...prev,
            sonSezioni: [...prev.sonSezioni, nuovaSezione]
        }));
    };

    useEffect(() => {
        // Mantiene la logica init per eseguire solo una volta
        if (init) {
            if (props.gestisci === "aggiungi-sondaggio") {
                setSonStato(statiSondaggio.NonPubblicato);
                setInit(false); // Imposta init a false anche qui
            } else if (props.gestisci === "controlla-sondaggio" && props.sonId) { // Aggiunto controllo props.sonId
                setCaricandoSondaggio(true);

                // Definisci le due chiamate API come promesse
                const sondaggioPromise = SondaggioService.getSondaggioById(props.sonId);
                const intervalliPromise = IntervalloPunteggioService.getIntervalloBySondaggioId(props.sonId);

                // Esegui entrambe le chiamate in parallelo
                Promise.all([sondaggioPromise, intervalliPromise])
                    .then(([sondaggioRes, intervalliRes]) => {
                        // --- Processa i dati del Sondaggio ---
                        const sondaggio = sondaggioRes.data;
                        if (sondaggio) { // Controlla se i dati del sondaggio esistono
                            const dataInizio = dayjs(sondaggio.sonDataInizio).format("YYYY-MM-DD");
                            const oraInizio = dayjs(sondaggio.sonDataInizio).format("HH");
                            const dataChiusura = dayjs(sondaggio.sonDataChiusura).format("YYYY-MM-DD");
                            const oraChiusura = dayjs(sondaggio.sonDataChiusura).format("HH");

                            // Ordina sezioni e domande (come prima)
                            const sezioniOrdinate = (sondaggio.sezioni || [])
                                .sort((a, b) => a.sezPosizione - b.sezPosizione)
                                .map((sez) => {
                                    const domandeOrdinate = (sez.domande || [])
                                        .sort((a, b) => a.domNumPosizione - b.domNumPosizione)
                                        .map((dom) => ({
                                            domId: dom.domId,
                                            domDomanda: dom.domDomanda,
                                            domNumPosizione: dom.domNumPosizione,
                                            domTabellaPredefinita: dom.domTabellaPredefinita || false,
                                            domObbligatoria: dom.domObbligatoria || false,
                                            tipDomMultipla: dom.tipoDomanda?.tipDomMultipla || false,
                                            tipDomMinRisposte: dom.tipoDomanda?.tipDomMinRisposte ?? 1,
                                            tipDomMaxRisposte: dom.tipoDomanda?.tipDomMaxRisposte ?? 1,
                                            opzioniRisposta: (dom.opzioniRisposte || [])
                                                .sort((a, b) => a.opzRisPosizione - b.opzRisPosizione)
                                                .map((opz) => ({
                                                    opzRisId: opz.opzRisId,
                                                    opzRisTesto: opz.opzRisTesto,
                                                    opzRisPunteggio: opz.opzRisPunteggio,
                                                    opzRisPosizione: opz.opzRisPosizione,
                                                    opzRisSezSuccessiva: opz.opzRisSezSuccessiva,
                                                    opzRisFlTermina: opz.opzRisFlTermina
                                                }))
                                        }));
                                    return {
                                        sezId: sez.sezId,
                                        sezNome: sez.sezNome,
                                        sezPosizione: sez.sezPosizione,
                                        domande: domandeOrdinate
                                    };
                                });

                            // Imposta lo stato del form e altri stati relativi al sondaggio
                            setForm({
                                sonTitolo: sondaggio.sonTitolo || "",
                                sonDataInizio: dataInizio,
                                sonOraInizio: oraInizio,
                                sonDataChiusura: dataChiusura,
                                sonOraChiusura: oraChiusura,
                                sonDescrizione: sondaggio.sonDescrizione || "",
                                sonTipoPunteggio: sondaggio.sonTipoPunteggio || false,
                                sonSezioni: sezioniOrdinate
                            });
                            setSonId(sondaggio.sonId);
                            setSonStato(sondaggio.sonStato);
                            dataInizioCurrent = sondaggio.sonDataInizio; // Nota: questa variabile non è uno stato
                            if (sondaggio.sonBanner) {
                                setFile(`data:image/png;base64,${sondaggio.sonBanner}`);
                                setUploadedFilesMetadata({ name: sondaggio.sonBannerNome || 'banner.png' });
                            } else {
                                setFile(null);
                                setUploadedFilesMetadata([]);
                            }
                            setPunteggi(sondaggio.sonTipoPunteggio || false); // Imposta lo stato 'punteggi'

                            // Categorie
                            const categorieSelezionate = sondaggio.sonCategorie?.categorie?.map((cat, index) => ({
                                name: cat,
                                id: index // Potrebbe essere meglio usare un ID più stabile se disponibile
                            })) || [];
                            setSelectedOptions(categorieSelezionate);

                        } else {
                            console.error("Dati sondaggio non validi ricevuti:", sondaggioRes);
                            // Gestisci l'errore, magari mostrando un messaggio
                            setMostraModaleErrore(true);
                            setTitolo("Errore Caricamento");
                            setMessaggio("Impossibile caricare i dati del sondaggio.");
                        }


                        // --- Processa i dati degli Intervalli ---
                        const loadedIntervals = intervalliRes.data;
                        if (loadedIntervals && Array.isArray(loadedIntervals) && loadedIntervals.length > 0) {
                            setIntervalliPunteggio(loadedIntervals);
                        } else {
                            setIntervalliPunteggio([]); // Imposta a vuoto se non ci sono o non sono validi
                        }

                    })
                    .catch(err => {
                        console.error("Errore durante il caricamento dei dati (sondaggio o intervalli):", err);
                        // Gestisci l'errore generale
                        setMostraModaleErrore(true);
                        setTitolo("Errore Caricamento");
                        setMessaggio("Errore durante il recupero dei dati del sondaggio o degli intervalli.");
                        // Resetta stati importanti in caso di errore
                        setForm({ /* stato iniziale vuoto */ });
                        setIntervalliPunteggio([]);
                        setPunteggi(false);
                    })
                    .finally(() => {
                        setCaricandoSondaggio(false);
                        setInit(false); // Imposta init a false alla fine del caricamento
                    });
            } else {
                // Se non siamo in 'controlla-sondaggio' o manca sonId, imposta init a false
                setInit(false);
            }
        }
        // Rimuovi 'init' dalle dipendenze se vuoi che si ricarichi se props.sonId cambia
        // }, [props.gestisci, props.sonId]);
        // Mantieni 'init' se vuoi caricarlo *solo* la prima volta che il componente monta con queste props
    }, [init, props.gestisci, props.sonId]);


    //funzioni per il caricamento del file banner
    const handleDisplayFileDetails = async () => {
        if (inputFile?.files && inputFile.files[0]
            && inputFile.files[0].size <= max_dimensione_banner_sondaggi // controlla grandezza file < 1MB
            && acceptedExtensions.includes(inputFile.files[0].type) // controlla estensione
        ) {
            setUploadedFilesMetadata(inputFile.files[0])
            setFile(URL.createObjectURL(inputFile.files[0]));
            setErroreAllegati("")
        } else {
            if (uploadedFilesMetadata.filter(file => file.name === inputFile.files[0].name).length > 1) setErroreAllegati("Non puoi caricare file con lo stesso nome.")
            else if (!acceptedExtensions.includes(inputFile.files[0].type)) setErroreAllegati("Il formato del file scelto non è accettabile.")
            else if (!inputFile.files[0].size <= max_dimensione_banner_sondaggi) setErroreAllegati("Il file scelto è troppo grande. Riprova.")
        }
    }

    const handleUpload = (event) => {
        event.preventDefault()
        inputFile?.click();
    };

    const deleteFile = () => {
        setUploadedFilesMetadata([])
        setFile()
    }

    //Aggiunta dell'asterisco per i campi obbligatori
    const mandatoryField = () => {
        if (["aggiungi-sondaggio", "controlla-sondaggio"].includes(props.gestisci)) {
            return <span>*</span>
        } else {
            return ""
        }
    }

    const mostraIntervalliEsistenti = () => {
        // Non serve più caricare i dati qui, dovrebbero essere già in intervalliPunteggio
        const { punteggioMin, punteggioMax } = calcolaPunteggioTotale();
        setPunteggioRange({ punteggioMin, punteggioMax });
        // Mostra semplicemente il modal in modalità readonly
        setMostraSoloLetturaIntervalli(true);
    };

    const getValidationStyle = (field) => {
        return (validato ? (errori[field] ? "is-invalid" : "is-valid") : "")
    }

    //Quando un campo viene modificato nel form viene qui per settare i dati del form e vedere gli errori
    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value
        })

        // Controllo se ci sono errori, e li rimuovo dall'oggetto Errors
        if (!!errori[field]) // Se c'era un errore per questo campo specifico
            setErrori({  // Aggiorna lo stato degli errori
                ...errori,
                [field]: null // Rimuovi l'errore per quel campo
            })
    }



    const isErrors = (nuoviErrori) => {
        if (!nuoviErrori || typeof nuoviErrori !== "object") return false;

        // Se ci sono errori a livello globale
        if (Object.keys(nuoviErrori).some(k => k !== "erroriDomande")) return true;

        // Se ci sono errori nelle domande (almeno un oggetto non vuoto)
        return (nuoviErrori.erroriDomande || []).some(
            sezione => sezione.some(domErr => Object.keys(domErr).length > 0)
        );
    };
    const clearErroreDomanda = (campo, secIdx, domIdx) => {
        setErrori(prevErrori => {
            // Use optional chaining for safer access
            if (!prevErrori?.erroriDomande?.[secIdx]?.[domIdx]?.[campo]) {
                return prevErrori;
            }
            const nuoviErrori = JSON.parse(JSON.stringify(prevErrori)); // Deep clone
            if (nuoviErrori.erroriDomande?.[secIdx]?.[domIdx]) {
                delete nuoviErrori.erroriDomande[secIdx][domIdx][campo];
            }


            return nuoviErrori;
        });
    };

    //Azioni 
    const handleSubmit = (saveType, e) => {
        e.preventDefault()

        setValidato(true);
        setCategoriaValidata(true); // Ora le categorie possono essere evidenziate se c'è un errore


        const multiselect = select;
        multiselect.searchWrapper.current.classList.remove("invalid", "border", "border-success");

        //Ottieni i nuovi errori
        let nuoviErrori = checkSondaggio()

        if (isErrors(nuoviErrori)) {
            //Presenza di errori: inserimento nell'oggetto Errori e submit bloccato
            setErrori(nuoviErrori)

            scrollToFirstError(nuoviErrori);

            // Mostra banner
            setErroreValidazioneForm(true);
            // ✅ Nascondi banner dopo 10 secondi
            setTimeout(() => setErroreValidazioneForm(false), 10000);
            if (nuoviErrori.sonCategorie) {
                multiselect.searchWrapper.current.classList.add("invalid", "border", "border-danger");
            } else {
                multiselect.searchWrapper.current.classList.add("is-valid", "border", "border-success");

            }
            return; // blocca il submit se ci sono errori
        } else {
            //Assenza di errori! Submit del form abilitato 
            if (selectedOptions.length > 0) {
                multiselect.searchWrapper.current.classList.add("is-valid", "border", "border-success");
            }
            if (punteggi) {
                const { punteggioMin, punteggioMax } = calcolaPunteggioTotale();
                setPunteggioRange({ punteggioMin, punteggioMax });
                setAzionePending(saveType);

                //  DEBUG: stampa punteggio massimo dinamico
                //const punteggioMassimoDinamico = calcolaPunteggioMassimoDinamico();
                //console.log("Punteggio massimo calcolato dinamicamente:", punteggioMassimoDinamico);

                // --- PREPARA I DATI PER IL MODAL ---
                setIntervalliPerModal(intervalliPunteggio || []);
                setMostraModaleIntervalli(true);
                return;
            }
            if (saveType === "salva-bozza") {
                salvaSondaggio(saveType);
            } else {
                setParolaChiave(saveType === "pubblica" ? "pubblica" : "Salva");
                setTitolo(saveType === "pubblica" ? "Pubblicazione dell'elemento" : "Salva l'elemento");
                setMessaggio(saveType === "pubblica" ? "Sei sicuro di voler pubblicare l'elemento? L'operazione è irreversibile!" : "Sei sicuro di voler modificare l'elemento? L'operazione è irreversibile!");
                setMostraModaleOperazione(true);
            }
        }
    }

    const salvaSondaggio = async (saveType, intervalliDaSalvare = []) => {
        try {
            const formatDateTime = (date, hour) => dayjs(`${date} ${hour}:00`, "YYYY-MM-DD HH:mm").toISOString();
            const dataInizio = formatDateTime(form.sonDataInizio, form.sonOraInizio);
            const dataChiusura = formatDateTime(form.sonDataChiusura, form.sonOraChiusura);

            let stato;
            if (saveType === "salva-bozza") {
                stato = statiSondaggio.NonPubblicato;
            } else {
                stato = dayjs().isBefore(dayjs(dataInizio)) ? statiSondaggio.Pubblicato : statiSondaggio.InCorso;
            }


            const sondaggio = {
                sonId: props.gestisci === "controlla-sondaggio" ? sonId : undefined,
                sonTitolo: form.sonTitolo,
                sonDataInizio: dataInizio,
                sonDataChiusura: dataChiusura,
                sonCategorie: { categorie: selectedOptions.map(el => el.name) },
                sonTipoPunteggio: punteggi,
                sonDescrizione: form.sonDescrizione,
                comId: props.comune.comId,
                sonStato: stato,
            };

            const sezioni = form.sonSezioni.map((sez, index) => ({
                sezId: sez.sezId || null,
                sezNome: sez.sezNome,
                sezPosizione: index + 1,
                sonId: sondaggio.sonId || null // verrà sovrascritto dal backend comunque
            }));

            const domande = [];
            const mappaPosizioneSezId = {};
            sezioni.forEach(s => {
                mappaPosizioneSezId[s.sezPosizione] = s.sezId;
            });
            form.sonSezioni.forEach((sez, i) => {
                sez.domande.forEach((d, domIndex) => {

                    domande.push({
                        domId: d.domId || null,
                        domDomanda: d.domDomanda,
                        domNumPosizione: domIndex + 1,
                        domTabellaPredefinita: d.domTabellaPredefinita || false,
                        domObbligatoria: d.domObbligatoria || false,
                        sezId: i + 1,
                        sonId: sondaggio.sonId || null,
                        tipoDomanda: {
                            tipDomMultipla: d.tipDomMultipla,
                            tipDomMinRisposte: d.tipDomMultipla
                                ? (d.tipDomMinRisposte === null || d.tipDomMinRisposte === undefined ? 0 : d.tipDomMinRisposte) // Se multipla: default 0 se null/undef, altrimenti usa valore (anche 0)
                                : 1, // Se singola: default 1 (o null?)
                            tipDomMaxRisposte: d.tipDomMultipla
                                ? (d.tipDomMaxRisposte === null || d.tipDomMaxRisposte === undefined ? 1 : d.tipDomMaxRisposte) // Se multipla: default 1 se null/undef, altrimenti usa valore
                                : 1, // Se singola: default 1 (o null?)
                            tipDomSingola: !d.tipDomMultipla
                        },
                        opzioniRisposte: d.opzioniRisposta.map((opz, idx) => {
                            let sezSuccessiva = null;

                            const rawVal = opz.opzRisSezSuccessiva;
                            if (rawVal !== "" && rawVal != null) {
                                let resolvedId = rawVal;

                                // ⚠️ Se è oggetto (es. { sezId: 5 }), prendi l'ID
                                if (typeof resolvedId === "object" && resolvedId.sezId) {
                                    resolvedId = resolvedId.sezId;
                                }

                                // Controllo finale: se è un numero e NON è tra quelli da eliminare, lo assegni
                                if (!isNaN(resolvedId) && !sezioniToDelete.includes(parseInt(resolvedId))) {
                                    sezSuccessiva = parseInt(resolvedId);
                                }


                            }

                            let punteggioDaSalvare = null; // Default a null se i punteggi NON sono attivi
                            if (punteggi) { // Controlla se la modalità punteggi è attiva
                                const valoreForm = opz.opzRisPunteggio;
                                // Se il valore è null, undefined o stringa vuota, imposta 0
                                if (valoreForm === null || valoreForm === undefined || valoreForm === '') {
                                    punteggioDaSalvare = 0;
                                } else {
                                    // Altrimenti, usa il valore presente (assicurati sia numero, anche se dovrebbe esserlo)
                                    punteggioDaSalvare = parseInt(valoreForm, 10);
                                    // Fallback a 0 se parseInt fallisce (anche se non dovrebbe con type="number")
                                    if (isNaN(punteggioDaSalvare)) {
                                        punteggioDaSalvare = 0;
                                    }
                                }
                            }

                            return {
                                opzRisId: opz.opzRisId || null,
                                opzRisTesto: opz.opzRisTesto,
                                opzRisPunteggio: punteggioDaSalvare,
                                opzRisPosizione: idx + 1,
                                opzRisSezSuccessiva: sezSuccessiva,
                                opzRisFlTermina: opz.opzRisFlTermina
                            };
                        })

                    });
                });
            });

            const dto = {
                sondaggio,
                sezioni,
                domande,
                domandeDaEliminare: domandeToDelete || [],
                sezioniDaEliminare: sezioniToDelete || [],
                intervalliPunteggio: punteggi && !tuttiPunteggiSonoZero()
                    ? intervalliDaSalvare.map(intervallo => ({
                        intPunId: intervallo.intPunId || null,
                        intPunMin: intervallo.intPunMin,
                        intPunMax: intervallo.intPunMax,
                        intPunDescrizione: intervallo.intPunDescrizione,
                        sonId: sondaggio.sonId || null
                    }))
                    : [] // ← cancella se disattivo o tutti a 0

            };



            // Chiamata unica
            const formData = new FormData();
            formData.append("dto", JSON.stringify(dto));

            if (uploadedFilesMetadata instanceof File) {
                formData.append("file", uploadedFilesMetadata);
                formData.append("fileToDelete", "false");
            } else if (!uploadedFilesMetadata || uploadedFilesMetadata.length === 0) {
                formData.append("fileToDelete", "true");
            }

            await SondaggioService.salvaCompleto(formData);
            if (props.gestisci === "aggiungi-sondaggio" && !props.sonId) {
                console.log("GestisciSondaggio: Clearing draft for new survey after successful save.");
                localStorage.removeItem(DRAFT_KEY_NEW_SONDAGGIO);
            }

            setMostraModaleSuccesso(true);
            setTitolo(saveType === "salva-bozza" ? "Bozza salvata" : "Salvataggio riuscito");
            setMessaggio("Sondaggio salvato con successo");
        } catch (error) {
            console.error("Errore nel salvataggio:", error);
            setMostraModaleErrore(true);
            setTitolo("Errore");
            setMessaggio("Errore durante il salvataggio del sondaggio");
        } finally {
            props.setDirty(true);
            setMostraModaleOperazione(false);
        }
    };

    //Check per errori all'handle submit
    const checkSondaggio = () => {
        const { sonTitolo, sonDataInizio, sonDataChiusura, sonDescrizione, sonSezioni, sonOraInizio, sonOraChiusura } = form
        let nuoviErrori = {}
        nuoviErrori = checkTitolo(sonTitolo, nuoviErrori)
        nuoviErrori = checkDate(sonDataInizio, sonDataChiusura, sonOraInizio, sonOraChiusura, nuoviErrori)
        nuoviErrori = checkDescrizione(sonDescrizione, nuoviErrori)
        nuoviErrori = checkCategorie(selectedOptions, nuoviErrori);
        nuoviErrori = checkDomande(nuoviErrori)
        return nuoviErrori
    }

    // Function to handle cancellation, passed to AzioniSondaggio
    const handleCancel = () => {
        if (props.gestisci === "aggiungi-sondaggio" && !props.sonId) {
            console.log("GestisciSondaggio: Clearing draft on cancel new survey.");
            localStorage.removeItem(DRAFT_KEY_NEW_SONDAGGIO);
        }
        props.setMostraTabella(true); // Navigate back to the table
    };

    const checkTitolo = (sonTitolo, nuoviErrori) => {
        //TODO SONDAGGI: aggiungere anche controllo sulla lunghezza??
        if (!sonTitolo || sonTitolo.trim() === '') {
            nuoviErrori.sonTitolo = "Inserisci un titolo valido (non può essere vuoto o contenere solo spazi)";
        }
        return nuoviErrori
    }


    const checkCategorie = (selectedOptions, nuoviErrori) => {
        const multiselect = select
        if (!selectedOptions || selectedOptions.length === 0 || multiselect.getSelectedItemsCount() === 0) {
            nuoviErrori.sonCategorie = "Seleziona almeno una categoria";
        }
        return nuoviErrori
    }

    const checkDate = (sonDataInizio, sonDataChiusura, sonOraInizio, sonOraChiusura, nuoviErrori) => {
        let errore = false
        // Inizia prima di return
        const oraInizio = parseInt(sonOraInizio);
        const oraChiusura = parseInt(sonOraChiusura);
        const dataInizio = dayjs(sonDataInizio)
        const dataChiusura = dayjs(sonDataChiusura)
        const messaggi = {
            dataInizioRichiesta: "Inserisci la data di inizio",
            dataFineRichiesta: "Inserisci la data di chiusura",
            dataNonValida: "Controllare i valori delle date inserite",
            dataInizioPrimaDiOggi: "La data di inizio non può essere inferiore alla data di oggi",
            dataInizioPrecedenteDataDb: "La data di inizio non può essere inferiore a quella precedentemente salvata",
            dataFinePrimaDataInizio: "La data di chiusura non può essere antecedente alla data di inizio",
            dataInizioUgualeDataFine: "La data di chiusura e di inizio non possono coincidere"

        }

        if (isNaN(oraInizio) || oraInizio < 0 || oraInizio > 23) {
            nuoviErrori.sonOraInizio = "L'ora di inizio deve essere compresa tra 0 e 23";
        }

        if (isNaN(oraChiusura) || oraChiusura < 0 || oraChiusura > 23) {
            nuoviErrori.sonOraChiusura = "L'ora di chiusura deve essere compresa tra 0 e 23";
        }
        //La Data di inizio non può essere vuota
        if (!sonDataInizio || sonDataInizio === '') {
            nuoviErrori.sonDataInizio = messaggi.dataInizioRichiesta
            errore = true
        }
        // La data di chiusura non può essere vuota
        if (!sonDataChiusura || sonDataChiusura === '') {
            nuoviErrori.sonDataChiusura = messaggi.dataFineRichiesta
            errore = true
        }
        if (!errore) {
            // La data di inizio deve essere valida
            if (dayjs(sonDataInizio, 'YYYY-MM-DD', true).isValid() === false) {
                nuoviErrori.sonDataInizio = messaggi.dataNonValida
                errore = true
            }
            // La data di chiusura deve essere valida
            if (dayjs(sonDataChiusura, 'YYYY-MM-DD', true).isValid() === false) {
                nuoviErrori.sonDataChiusura = messaggi.dataNonValida
                errore = true
            }
            const inizioDateTime = dayjs(`${sonDataInizio} ${form.sonOraInizio}:00`, "YYYY-MM-DD HH:mm");
            const fineDateTime = dayjs(`${sonDataChiusura} ${form.sonOraChiusura}:00`, "YYYY-MM-DD HH:mm");
            const now = dayjs();
            // Data e ora di inizio non possono essere prima di ora
            if (props.gestisci === "aggiungi-sondaggio" && inizioDateTime.isBefore(now)) {
                nuoviErrori.sonDataInizio = "La data e ora di inizio non possono essere nel passato";
                nuoviErrori.sonOraInizio = "La data e ora di inizio non possono essere nel passato";
            }

            // Data di fine non può essere prima di quella di inizio
            if (fineDateTime.isBefore(inizioDateTime)) {
                nuoviErrori.sonDataChiusura = "La data di fine non può essere prima dell'inizio";
                nuoviErrori.sonOraChiusura = "La data di fine non può essere prima dell'inizio";
            }

            if (fineDateTime.isSame(inizioDateTime)) {
                nuoviErrori.sonDataChiusura = "La data di fine non può coincidere con quella di inizio"
                nuoviErrori.sonOraChiusura = "La data di fine non può coincidere con quella di inizio"
            }
        }

        // In inserimento del sondaggio la data di inizio non può essere inferiore a oggi
        if (!errore) {
            if (props.gestisci === "aggiungi-sondaggio" && !permettiDataInizioPrimaDiOggi) {
                let today = dayjs(new Date(dayjs().year(), dayjs().month(), dayjs().date()))
                if (dayjs(dataInizio).isBefore(today, 'd')) {
                    nuoviErrori.sonDataInizio = messaggi.dataInizioPrimaDiOggi
                    errore = true
                }
            }
        }

        // In modifica del sondaggio la data di inizio non può essere inferiore a quella salvata in db
        if (!errore) {
            if (props.gestisci !== "aggiungi-sondaggio" && !permettiDataInizioSondaggioPrecedenteDataInizioDb) {
                if (dayjs(dataInizio).isBefore(dayjs(dataInizioCurrent), 'd')) {
                    nuoviErrori.sonDataInizio = messaggi.dataInizioPrecedenteDataDb
                    errore = true
                }
            }
        }

        // La data di chiusura non può essere antecedente alla data di inizio
        if (!errore) {
            if (dayjs(dataChiusura).isBefore(dayjs(dataInizio), 'd')) {
                nuoviErrori.sonDataChiusura = messaggi.dataFinePrimaDataInizio
                errore = true
            }
        }

        return nuoviErrori
    }




    const checkDomande = (nuoviErrori) => {
        // Inizializza l'array degli errori per le sezioni, assicurando che abbia la lunghezza giusta
        nuoviErrori.erroriDomande = Array(form.sonSezioni.length).fill(null).map(() => []);

        form.sonSezioni.forEach((sezione, sezioneIndex) => {
            // Inizializza l'array degli errori per le domande di questa sezione
            const erroriDomandeSezione = Array(sezione.domande.length).fill(null).map(() => ({})); // Inizia con oggetti vuoti

            sezione.domande.forEach((dom, domandaIndex) => {
                const erroriDom = {};
                let ciSonoErroriOpzioni = false; // Flag per sapere se c'è almeno un errore nelle opzioni


                if (!dom.domDomanda || dom.domDomanda.trim() === "") {
                    erroriDom.domDomanda = "Inserisci il testo della domanda";
                }

                const opzioni = dom.opzioniRisposta || [];

                const erroriOpzioniTemp = []; // Array per contenere gli errori delle opzioni (anche vuoti)

                const opzioniValide = opzioni.filter(opz => opz.opzRisTesto && opz.opzRisTesto.trim() !== "");
                if (opzioniValide.length === 0) {
                    erroriDom.opzioni = "Aggiungi almeno un'opzione con un testo valido";
                } else {
                    // Validazione del testo delle opzioni
                    opzioni.forEach((opz, opzIndex) => { // Usa forEach o map per popolare erroriOpzioniTemp
                        const erroriOpzioneSingola = {}; // Oggetto per gli errori di QUESTA opzione
                        if (!opz.opzRisTesto || opz.opzRisTesto.trim() === "") {
                            erroriOpzioneSingola.opzRisTesto = "Inserisci il testo dell'opzione";
                            ciSonoErroriOpzioni = true; // Imposta il flag se trovi un errore
                        }
                        erroriOpzioniTemp[opzIndex] = erroriOpzioneSingola; // Assegna l'oggetto (vuoto o con errori) all'indice corretto
                    });

                    // Assegna l'array degli errori delle opzioni all'oggetto erroriDom SOLO se c'è stato almeno un errore
                    if (ciSonoErroriOpzioni) {
                        erroriDom.opzioniRisposta = erroriOpzioniTemp; // MANTIENE LA STRUTTURA COMPLETA
                    }
                }

                // Validazione Min/Max per domande multiple
                if (dom.tipDomMultipla) {
                    let min = 0;
                    if (dom.domObbligatoria) {
                        min = parseInt(dom.tipDomMinRisposte ?? 1); // Default a 1 se null/undefined
                    } else {
                        min = parseInt(dom.tipDomMinRisposte ?? 0); // Default a 0 se null/undefined e non obbligatoria
                    }

                    const max = parseInt(dom.tipDomMaxRisposte ?? 1); // Default a 1 se null/undefined
                    const numOpzioni = opzioni.length;

                    // Controlli più robusti per NaN
                    const minValido = !isNaN(min) && min >= 0;
                    const maxValido = !isNaN(max) && max >= 0;

                    if (!minValido) {
                        erroriDom.tipDomMinRisposte = "Valore minimo non valido";
                    }
                    if (!maxValido) {
                        erroriDom.tipDomMaxRisposte = "Valore massimo non valido";
                    }

                    if (minValido && maxValido) {
                        if (dom.domObbligatoria && min < 1) {
                            erroriDom.tipDomMinRisposte = "Minimo 1 per domande obbligatorie";
                        }
                        // Se non obbligatoria, min può essere 0, ma non >= numOpzioni (a meno che numOpzioni sia 0)
                        if (!dom.domObbligatoria && numOpzioni > 0 && min >= numOpzioni) {
                            erroriDom.tipDomMinRisposte = `Minimo deve essere < ${numOpzioni}`;
                        }
                        if (max < min) {
                            erroriDom.tipDomMaxRisposte = "Massimo >= Minimo";
                        }
                        if (max > numOpzioni) {
                            erroriDom.tipDomMaxRisposte = `Massimo <= ${numOpzioni}`;
                        }
                        if (min > numOpzioni) { // Aggiunto controllo se min > numOpzioni
                            erroriDom.tipDomMinRisposte = `Minimo <= ${numOpzioni}`;
                        }
                    }
                }

                // Assegna l'oggetto erroriDom (che può contenere errori di domanda e/o opzioniRisposta)
                // all'array della sezione all'indice corretto.
                // Sovrascrive l'oggetto vuoto inizializzato prima solo se ci sono errori.
                if (Object.keys(erroriDom).length > 0) {
                    erroriDomandeSezione[domandaIndex] = erroriDom;
                }
            });

            // Assegna l'array degli errori delle domande di questa sezione all'array principale
            nuoviErrori.erroriDomande[sezioneIndex] = erroriDomandeSezione;
        });


        return nuoviErrori;
    };

    const checkDescrizione = (sonDescrizione, nuoviErrori) => {
        if (!sonDescrizione || sonDescrizione.trim() === '') {
            nuoviErrori.sonDescrizione = "Inserisci la descrizione"
        }

        return nuoviErrori
    }

    //gestisci selezione delle categorie
    const handleSelect = (_, selectedItem) => {
        setSelectedOptions(old => [...old, selectedItem])

        if (categoriaValidata) {
            // Se la categoria è stata validata e c'era un errore, rimuovi il bordo rosso e metti verde
            select.searchWrapper.current.classList.remove("invalid", "border", "border-danger");
            select.searchWrapper.current.classList.add("is-valid", "border", "border-success");
        }
        // Rimuovi l'errore se esiste e aggiungi la classe di validazione positiva
        setErrori(prevErrori => ({
            ...prevErrori,
            sonCategorie: null
        }));
    }

    const handleRemove = (_, removedItem) => {
        const newOptions = selectedOptions.filter(el => el.id !== removedItem.id);
        setSelectedOptions(newOptions);

        if (newOptions.length === 0 && categoriaValidata) {
            setErrori(prevErrori => ({
                ...prevErrori,
                sonCategorie: "Seleziona almeno una categoria"
            }));

            select.searchWrapper.current.classList.remove("is-valid", "border", "border-success");
            select.searchWrapper.current.classList.add("invalid", "border", "border-danger");
        }
    };

    useEffect(() => {
        let opt = []
        opt = props.comune.impostazioniComune && props.comune.impostazioniComune.imcCategorieSondaggi?.categorie_sondaggi?.map((el, i) => {
            return { "name": el, "id": i }
        })
        setOptions(opt)
    }, [props.comune.impostazioniComune])


    const deleteDomanda = (domanda_d) => {
        setMostraModaleDeleteDomanda(false);

        setForm((prevForm) => {
            const nuoveSezioni = prevForm.sonSezioni.map(sezione => {
                const domandeFiltrate = sezione.domande.filter(dom => dom.domId !== domanda_d.domId);

                // Riassegna le posizioni
                const domandeAggiornate = domandeFiltrate.map((dom, index) => ({
                    ...dom,
                    domNumPosizione: index + 1,
                }));

                return {
                    ...sezione,
                    domande: domandeAggiornate
                };
            });

            // Aggiungi alla lista di domande da eliminare
            if (props.gestisci === "controlla-sondaggio" && domanda_d.domId) {
                setDomandeToDelete((prev) => [...prev, domanda_d.domId]);
            }

            return {
                ...prevForm,
                sonSezioni: nuoveSezioni
            };
        });
    };

    useEffect(() => {
        // Load draft ONLY if we are in "aggiungi-sondaggio" mode AND it's not an existing survey being loaded
        // props.sonId will be null/undefined for a new survey.
        if (props.gestisci === "aggiungi-sondaggio" && !props.sonId) {
            const draftString = localStorage.getItem(DRAFT_KEY_NEW_SONDAGGIO);
            if (draftString) {
                try {
                    const parsedDraft = JSON.parse(draftString);
                    console.log("GestisciSondaggio: Loading draft for new survey:", parsedDraft);
                    if (parsedDraft.form) setForm(parsedDraft.form);
                    if (parsedDraft.selectedOptions) setSelectedOptions(parsedDraft.selectedOptions);
                    if (parsedDraft.punteggi !== undefined) setPunteggi(parsedDraft.punteggi);
                    // Restore other states if they were part of the draft
                } catch (err) {
                    console.error("GestisciSondaggio: Error parsing draft:", err);
                    localStorage.removeItem(DRAFT_KEY_NEW_SONDAGGIO); // Clear corrupted draft
                }
            }
        }
    }, [props.gestisci, props.sonId]); // Rerun if gestisci or sonId changes

    // --- DRAFT SAVING for NEW surveys ---
    useEffect(() => {
        // Save draft ONLY if we are in "aggiungi-sondaggio" mode AND it's not an existing survey
        if (props.gestisci === "aggiungi-sondaggio" && !props.sonId) {
            const statoDraft = {
                form,
                selectedOptions,
                punteggi,
                // Add any other relevant state for the draft here
            };
            // console.log("GestisciSondaggio: Saving draft for new survey:", statoDraft); // For debugging
            localStorage.setItem(DRAFT_KEY_NEW_SONDAGGIO, JSON.stringify(statoDraft));
        }
    }, [form, selectedOptions, punteggi, props.gestisci, props.sonId]); // Rerun on these changes

    const [draftEsistente, setDraftEsistente] = useState(false);
    useEffect(() => {
        const draft = localStorage.getItem(DRAFT_KEY_NEW_SONDAGGIO);
        console.log("GestisciSondaggio: Draft esistente:", draft);
            if (draft) {
                try {
                    const parsedDraft = JSON.parse(draft);
                    console.log("GestisciSondaggio: Loading draft for new survey:", parsedDraft);
                    if (parsedDraft.form){ setDraftEsistente(true)}else{
                        setDraftEsistente(false)
                    }
                } catch (err) {
                    console.error("GestisciSondaggio: Error parsing draft:", err);
                    localStorage.removeItem(DRAFT_KEY_NEW_SONDAGGIO); // Clear corrupted draft
                }
            }
    }, []);

    const resetForm = () => {
        setForm({
            sonTitolo: '',
            sonDescrizione: '',
            sonDataInizio: '',
            sonDataChiusura: '',
            sonOraInizio: '',
            sonOraChiusura: '',
            sonSezioni: [],
        });
        setSelectedOptions([]);
        setPunteggi(false);
        localStorage.removeItem("draftSondaggio");
    };

    return (
        <>
            <Container>
                {props.gestisci === "aggiungi-sondaggio" && <h2 className="title2">Nuovo elemento</h2>}
                {props.gestisci === "controlla-sondaggio" && <h2 className="title2">Controlla elemento</h2>}

                {["aggiungi-sondaggio", "controlla-sondaggio"].includes(props.gestisci) &&
                    <Row>
                        <Col className="mb-4 italic required-alert">I campi contrassegnati da un asterisco (*) sono obbligatori</Col>
                        <Col> {draftEsistente && (
                            <Button variant="outline-danger" onClick={resetForm}>
                                Reset sondaggio
                            </Button>
                        )}</Col>
                    </Row>
                }
                {caricandoSondaggio && props.gestisci === "controlla-sondaggio" ?
                    (
                        // Mentre il sondaggio è in caricamento, mostra lo Spinner
                        <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
                            <div className="text-center">
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Caricamento...</span>
                                </Spinner>
                                <p className="mt-3">Caricamento dati...</p>
                            </div>
                        </div>
                    ) : (

                        <Form className={validato === true ? "validato" : "non-validato"}>
                            <Row>
                                <Col>
                                    <Form.Group className="mb-3" id="sondaggio-titolo-group">
                                        <Form.Label>
                                            <strong>Titolo: </strong>
                                            {mandatoryField()}
                                        </Form.Label>
                                        <Form.Control
                                            type='text'
                                            value={form.sonTitolo}
                                            onChange={e => setField('sonTitolo', e.target.value)}
                                            className={getValidationStyle("sonTitolo")}
                                            placeholder="Inserisci il titolo del sondaggio"
                                            aria-describedby="sondaggio-titolo-feedback"
                                        />
                                        <Form.Control.Feedback type="invalid" id="sondaggio-titolo-feedback">
                                            <strong>{errori.sonTitolo}</strong>
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-3" id="sondaggio-date-group">
                                {/* Data di inizio */}
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label><strong>Data Inizio:</strong> {mandatoryField()}</Form.Label>
                                        <Form.Control
                                            aria-describedby="sondaggio-data-inizio-feedback"
                                            type="date"
                                            value={form.sonDataInizio}
                                            onChange={e => setField('sonDataInizio', e.target.value)}
                                            className={getValidationStyle("sonDataInizio")}
                                        />
                                    </Form.Group>
                                    <Form.Control.Feedback type="invalid" id="sondaggio-data-inizio-feedback">
                                        <strong>{errori.sonDataInizio}</strong>
                                    </Form.Control.Feedback>

                                </Col>

                                {/* Ora di inizio */}
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label><strong>Ora Inizio:</strong></Form.Label>
                                        <Form.Control
                                            as="select"
                                            value={form.sonOraInizio}
                                            onChange={e => setField('sonOraInizio', e.target.value)}
                                            className={getValidationStyle("sonOraInizio")}
                                        >
                                            {[...Array(24).keys()].map(hour => (
                                                <option key={hour} value={hour.toString().padStart(2, '0')}>
                                                    {hour.toString().padStart(2, '0')}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            <strong>{errori.sonOraInizio}</strong>
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>

                                {/* Data di chiusura */}
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label><strong>Data Chiusura:</strong> {mandatoryField()}</Form.Label>
                                        <Form.Control
                                            aria-describedby="sondaggio-data-chiusura-feedback"
                                            type="date"
                                            value={form.sonDataChiusura}
                                            onChange={e => setField('sonDataChiusura', e.target.value)}
                                            className={getValidationStyle("sonDataChiusura")}
                                        />
                                    </Form.Group>
                                    <Form.Control.Feedback type="invalid" id="sondaggio-data-chiusura-feedback">
                                        <strong>{errori.sonDataChiusura}</strong>
                                    </Form.Control.Feedback>
                                </Col>

                                {/* Ora di chiusura */}
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label><strong>Ora Chiusura:</strong></Form.Label>
                                        <Form.Control
                                            as="select"
                                            value={form.sonOraChiusura}
                                            onChange={e => setField('sonOraChiusura', e.target.value)}
                                            className={getValidationStyle("sonOraChiusura")}
                                        >
                                            {[...Array(24).keys()].map(hour => (
                                                <option key={hour} value={hour.toString().padStart(2, '0')}>
                                                    {hour.toString().padStart(2, '0')}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            <strong>{errori.sonOraChiusura}</strong>
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>


                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3" id="sondaggio-descrizione-group">
                                        <Form.Label>
                                            <strong>Descrizione: </strong>
                                            {mandatoryField()}
                                        </Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            aria-describedby="sondaggio-descrizione-feedback"
                                            rows={6}
                                            value={form.sonDescrizione}
                                            onChange={e => setField('sonDescrizione', e.target.value)}
                                            className={"no-resize " + getValidationStyle("sonDescrizione")}
                                            placeholder="Inserisci una descrizione per questo sondaggio"
                                        />
                                        <Form.Control.Feedback type='invalid' id="sondaggio-descrizione-feedback">
                                            <strong>{errori.sonDescrizione}</strong>
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-4" id="sondaggio-categorie-group">
                                        <Form.Label>
                                            <strong>Quali di questi aspetti interessano il sondaggio? </strong>
                                            {mandatoryField()}
                                        </Form.Label>
                                        <Multiselect required as="option" type="select"

                                            ref={el => select = el}
                                            options={options}
                                            selectedValues={selectedOptions}
                                            onSelect={handleSelect}
                                            onRemove={handleRemove}
                                            placeholder="Seleziona le categorie"
                                            displayValue="name"

                                            emptyRecordMsg="Nessuna opzione corrispondente"
                                        />
                                        {categoriaValidata && errori.sonCategorie && (
                                            <Form.Text className="text-danger">
                                                <strong>{errori.sonCategorie}</strong>
                                            </Form.Text>
                                        )}
                                    </Form.Group>
                                    <Form.Group className="mb-4">
                                        <Form.Label className="d-flex align-items-center gap-2">
                                            <strong>Sondaggio con punteggi?</strong>
                                            {mandatoryField()}
                                            {props.gestisci === "controlla-sondaggio" && punteggi && (
                                                <Button
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    onClick={mostraIntervalliEsistenti}
                                                    title="Visualizza intervalli punteggio"
                                                >
                                                    <FiEye />

                                                </Button>
                                            )}
                                        </Form.Label>



                                        <Form.Check
                                            type="switch"
                                            id="switch-punteggi"
                                            required
                                            label={punteggi ? "Attivato" : "Disattivato"}
                                            checked={punteggi}
                                            onChange={(ev) => {
                                                const isChecked = ev.target.checked;
                                                setPunteggi(isChecked);

                                                if (!isChecked) {
                                                    setIntervalliPunteggio([]);
                                                }
                                            }}

                                        />
                                    </Form.Group>

                                </Col>
                            </Row>
                            <Row className="mt-4 mb-3">
                                <Col md={6}>
                                    <strong>Carica banner</strong>
                                </Col>
                                <Col md={6} className="text-end">
                                    <div>
                                        <input
                                            className="d-none"
                                            type="file"
                                            multiple={true}
                                            ref={el => inputFile = el}
                                            onChange={handleDisplayFileDetails}
                                        />
                                        <Button onClick={handleUpload} disabled={uploadedFilesMetadata.name}>
                                            <FiUpload className="me-2" size="1em" />
                                            Carica
                                        </Button>
                                    </div>
                                </Col>
                                {erroreAllegati &&
                                    <Form.Label className="mt-1 text-danger d-block">
                                        <strong>{erroreAllegati}</strong>
                                    </Form.Label>
                                }
                            </Row>
                            {uploadedFilesMetadata.name && file &&
                                <Card className="text-center mb-4">
                                    <Card.Header className="d-flex justify-content-between">
                                        <strong className="my-auto">
                                            <BsFileEarmarkRichtext size={"1.5em"} />
                                            {uploadedFilesMetadata.name}
                                        </strong>
                                        <Button variant="outline-danger" onClick={() => deleteFile(uploadedFilesMetadata.name)}>
                                            <GoTrash size="1.5em" />
                                        </Button>
                                    </Card.Header>
                                    <Figure className="p-1 bannerSondaggio">
                                        <Figure.Image
                                            width={800}
                                            height={500}
                                            src={file}
                                        />
                                    </Figure>
                                </Card>
                            }

                            <DragDropContext onDragEnd={handleDragEnd}>
                                {form.sonSezioni?.map((sezione, index) => (
                                    <SezioneSondaggio
                                        key={index}
                                        index={index}
                                        sezioneIndex={index}
                                        sezione={sezione}
                                        clearErroreDomanda={clearErroreDomanda}
                                        onOptionFieldChange={handleOptionFieldChange}
                                        duplicaSezione={duplicaSezione}
                                        id={`sezione-${sezione.sezPosizione}`} // <-- Passa l'ID univoco
                                        setDomandaCompleta={(nuovaDomanda, domIdx) => { // domIdx è l'indice della domanda DENTRO la sezione
                                            const secIdx = index; // 'index' qui è l'indice della sezione nel map
                                            setForm(prevForm => {
                                                const nuoveSezioni = [...prevForm.sonSezioni];
                                                if (nuoveSezioni[secIdx] && nuoveSezioni[secIdx].domande[domIdx]) {
                                                    nuoveSezioni[secIdx].domande[domIdx] = nuovaDomanda; // Sostituisci l'oggetto domanda                                                  
                                                } else {
                                                    console.error(`Errore in setDomandaCompleta: Sezione ${secIdx} o Domanda ${domIdx} non trovata.`);
                                                }
                                                const newState = { ...prevForm, sonSezioni: nuoveSezioni };
                                                return newState;
                                            });
                                        }}
                                        erroriDomande={errori.erroriDomande?.[index]}
                                        handleDeleteSezione={handleDeleteSezione}
                                        mandatoryField={mandatoryField}
                                        aggiornaSezione={(idx, nuovaSezione) => {
                                            const nuoveSezioni = [...form.sonSezioni];
                                            nuoveSezioni[idx] = nuovaSezione;
                                            setForm({ ...form, sonSezioni: nuoveSezioni });
                                        }}
                                        aggiungiDomanda={(idx) => {
                                            const nuoveSezioni = [...form.sonSezioni];
                                            nuoveSezioni[idx].domande.push({
                                                domDomanda: "",
                                                tipDomMultipla: false,
                                                tipDomMinRisposte: null,
                                                tipDomMaxRisposte: null,
                                                domNumPosizione: nuoveSezioni[idx].domande.length + 1,
                                                domTabellaPredefinita: false,
                                                domObbligatoria: false,
                                                opzioniRisposta: [
                                                    {
                                                        opzRisTesto: "",
                                                        opzRisPunteggio: null,
                                                        opzRisPosizione: 1,
                                                        opzRisSezSuccessiva: null,
                                                        opzRisFlTermina: false
                                                    }
                                                ]
                                            });
                                            setForm({ ...form, sonSezioni: nuoveSezioni });
                                        }}
                                        eliminaDomanda={(secIdx, domIdx) => {
                                            handleDeleteDomandaRequest(secIdx, domIdx);
                                        }}
                                        validato={validato} // Passa lo stato 'validato' per combiare il colore dell'errore quando corretto
                                        modificaDomanda={(secIdx, domIdx, campo, valore) => {
                                            // 1. Aggiorna lo stato del form (come facevi già)
                                            setForm(prevForm => {
                                                const nuoveSezioni = [...prevForm.sonSezioni];
                                                // Controlli opzionali per robustezza
                                                if (nuoveSezioni[secIdx]?.domande[domIdx]) {
                                                    nuoveSezioni[secIdx].domande[domIdx] = {
                                                        ...nuoveSezioni[secIdx].domande[domIdx],
                                                        [campo]: valore // Aggiorna il campo specifico
                                                    };
                                                }
                                                return { ...prevForm, sonSezioni: nuoveSezioni };
                                            });

                                            // 2. AGGIUNGI QUESTA PARTE: Pulisci l'errore specifico per quel campo, SE ESISTEVA
                                            setErrori(prevErrori => {
                                                // Controlli robusti sulla struttura degli errori
                                                if (!prevErrori?.erroriDomande?.[secIdx]?.[domIdx]?.[campo]) {
                                                    // Se non c'era un errore specifico per questo campo, ritorna gli errori precedenti senza modifiche
                                                    return prevErrori;
                                                }

                                                // Crea copie per evitare mutazioni dirette dello stato
                                                const nuoviErrori = { ...prevErrori };
                                                const nuoviErroriDomande = [...nuoviErrori.erroriDomande]; // Copia array sezioni errore
                                                const nuoviErroriSezione = [...nuoviErroriDomande[secIdx]]; // Copia array domande errore della sezione
                                                const nuoviErroriDomanda = { ...nuoviErroriSezione[domIdx] }; // Copia oggetto errore della domanda

                                                // Rimuovi l'errore per il campo specifico
                                                delete nuoviErroriDomanda[campo]; // O imposta a null: nuoviErroriDomanda[campo] = null;

                                                // Aggiorna la struttura degli errori "risalendo"
                                                nuoviErroriSezione[domIdx] = nuoviErroriDomanda;
                                                nuoviErroriDomande[secIdx] = nuoviErroriSezione;
                                                nuoviErrori.erroriDomande = nuoviErroriDomande;

                                                return nuoviErrori; // Ritorna il nuovo stato degli errori aggiornato
                                            });
                                        }} // Fine della funzione inline modificata per modificaDomanda
                                        muoviDomanda={(secIdx, domIdx, direzione) => {
                                            const nuoveSezioni = [...form.sonSezioni];
                                            const domande = nuoveSezioni[secIdx].domande;

                                            // Protezione: evita movimenti illegali
                                            if (
                                                (direzione === "up" && domIdx === 0) ||
                                                (direzione === "down" && domIdx === domande.length - 1)
                                            ) return;

                                            const targetIdx = direzione === "up" ? domIdx - 1 : domIdx + 1;

                                            // Swap delle domande
                                            [domande[domIdx], domande[targetIdx]] = [domande[targetIdx], domande[domIdx]];

                                            // 🔁 Riassegna i numeri di posizione
                                            domande.forEach((dom, i) => {
                                                dom.domNumPosizione = i + 1;
                                            });

                                            nuoveSezioni[secIdx].domande = domande;

                                            setForm({ ...form, sonSezioni: nuoveSezioni });
                                        }}

                                        punteggioAttivo={punteggi}
                                        tutteLeDomande={form.sonSezioni.flatMap(s => s.domande)}
                                        mostraIntestazione={true}
                                        tutteLeSezioni={form.sonSezioni}
                                    />
                                ))}
                            </DragDropContext>
                            <Row className="align-items-center my-4">
                                <Col>
                                    <hr />
                                </Col>
                                <Col xs="auto" className="text-center">
                                    <Button onClick={aggiungiSezione} variant="secondary" size="sm">
                                        Aggiungi sezione <IoMdAdd />
                                    </Button>
                                </Col>
                                <Col>
                                    <hr />
                                </Col>
                            </Row>
                            {erroreValidazioneForm && (
                                <Row className="mb-4">
                                    <Col>
                                        <div style={{
                                            position: "relative",
                                            backgroundColor: "#fdecea",
                                            border: "1px solid #f5c2c7",
                                            color: "#842029",
                                            padding: "1rem 2rem 1rem 1rem",
                                            borderRadius: "0.375rem",
                                            textAlign: "center",
                                            fontWeight: "bold",
                                            fontSize: "1.1rem"
                                        }}>
                                            ⚠️ Ricontrolla i dati mancanti o non validi. Alcuni campi obbligatori non sono compilati correttamente.
                                            {/* Bottone di chiusura */}
                                            <button
                                                type="button"
                                                onClick={() => setErroreValidazioneForm(false)}
                                                style={{
                                                    position: "absolute",
                                                    top: "0.5rem",
                                                    right: "0.75rem",
                                                    background: "transparent",
                                                    border: "none",
                                                    fontSize: "1.2rem",
                                                    color: "#842029",
                                                    cursor: "pointer",
                                                    lineHeight: "1"
                                                }}
                                                aria-label="Chiudi"
                                            >
                                                ×
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            )}


                            <AzioniSondaggio
                                setMostraTabella={props.setMostraTabella}
                                sonStato={sonStato}
                                handleSubmit={handleSubmit}
                                onCancel={handleCancel} // NEW: Pass the cancel handler
                                isNewSondaggio={props.gestisci === "aggiungi-sondaggio" && !props.sonId}
                            />
                        </Form>
                    )
                }
            </Container>

            {/* modale di conferma operazione */}
            <ModalConferma
                mostra={mostraModaleOperazione}
                setMostra={setMostraModaleOperazione}
                mode={"continua"}
                titolo={titolo}
                messaggio={messaggio}
                bodyAlign="text-center"
                btnConferma={`Si, ${parolaChiave.toLowerCase()}`}
                btnAnnulla="No, annulla"
                azioneAnnulla={() => { setMostraModaleOperazione(false) }}
                azioneConferma={() => { salvaSondaggio(parolaChiave) }}
            />

            <ModalConferma
                mostra={mostraModaleDeleteDomanda}
                setMostra={setMostraModaleDeleteDomanda}
                mode={"continua"}
                titolo="Eliminazione domanda"
                messaggio="Confermi l'eliminazione della domanda?"
                bodyAlign="text-center"
                btnConferma={`Si, Elimina`}
                btnAnnulla="No, annulla"
                azioneAnnulla={() => { setMostraModaleDeleteDomanda(false) }}
                azioneConferma={() => { deleteDomanda(domandaToDelete) }}
            />

            {/* modali di esito operazione */}
            <ModalConferma
                mostra={mostraModaleSuccesso}
                setMostra={setMostraModaleSuccesso}
                mode="success"
                titolo={titolo}
                messaggio={messaggio}
                bodyAlign="text-center"
                btnConferma={`Torna a tutti i ${props.comune.impostazioniComune.imcLabelModuloSondaggi}`}
                azioneConferma={() => { props.setMostraTabella(true) }}
            />

            {/* modali di errore */}
            <ModalConferma
                mostra={mostraModaleErrore}
                setMostra={setMostraModaleErrore}
                mode="error"
                titolo={titolo}
                messaggio={messaggio}
                bodyAlign="text-center"
                btnConferma="Chiudi"
                azioneConferma={() => {
                    setMostraModaleErrore(false)
                }}
            />
            <ModalConferma
                mostra={mostraModaleDeleteSezione}
                setMostra={setMostraModaleDeleteSezione}
                mode="continua"
                titolo="Eliminazione sezione"
                messaggio="Sei sicuro di voler eliminare questa sezione? Tutte le domande e le risposte collegate verranno rimosse."
                bodyAlign="text-center"
                btnConferma="Sì, elimina"
                btnAnnulla="No, annulla"
                azioneAnnulla={() => setMostraModaleDeleteSezione(false)}
                azioneConferma={() => deleteSezione(sezioneToDelete)}
            />
            <ModalIntervalliPunteggio
                show={mostraSoloLetturaIntervalli}
                onClose={() => setMostraSoloLetturaIntervalli(false)}
                onSave={() => { }}
                punteggioMin={punteggioRange.punteggioMin}
                punteggioMax={punteggioRange.punteggioMax}
                intervalliPredefiniti={intervalliPunteggio}
                readonly
            />

            {/* Modale creazione/modifica intervalli punteggio */}
            <ModalIntervalliPunteggio
                show={mostraModaleIntervalli}
                intervalliPredefiniti={intervalliPerModal} // Passa lo stato attuale
                onClose={() => {
                    setMostraModaleIntervalli(false);
                    setAzionePending(null); // reset se chiudi
                    setIntervalliPerModal([]); // Pulisci stato temporaneo alla chiusura

                }}
                onSave={(nuoviIntervalli) => {

                    console.log("Modal onSave: Received from modal", nuoviIntervalli); // DEBUG
                    setIntervalliPunteggio(nuoviIntervalli); // Aggiorna stato intervalli principale
                    setMostraModaleIntervalli(false); // Chiudi modal intervalli

                    // --- CONTROLLA QUESTA PARTE ---
                    if (azionePending) { // azionePending contiene "salva-bozza", "pubblica" o "Salva"
                        // Passa gli intervalli ricevuti E l'azione originale
                        salvaSondaggio(azionePending, nuoviIntervalli); // <-- Qui passi gli intervalli
                    }
                    // --- FINE CONTROLLO ---

                    setAzionePending(null);
                    setIntervalliPerModal([]);
                }}
                punteggioMin={punteggioRange.punteggioMin}
                punteggioMax={punteggioRange.punteggioMax}
            />

            {/* Modale Conferma Eliminazione Domanda */}
            <ModalConferma
                mostra={mostraModaleDeleteDomanda}
                setMostra={setMostraModaleDeleteDomanda}
                mode={"continua"} // o "danger" per bottone rosso
                titolo="Eliminazione Domanda"
                messaggio="Sei sicuro di voler eliminare questa domanda?"
                bodyAlign="text-center"
                btnConferma="Sì, elimina"
                btnAnnulla="No, annulla"
                azioneAnnulla={() => {
                    setMostraModaleDeleteDomanda(false);
                    // Resetta gli indici anche se annulla
                    setDomandaToDeleteIndices({ secIdx: null, domIdx: null });
                }}
                azioneConferma={confermaEliminazioneDomanda} // Chiama la funzione di eliminazione effettiva
            />





        </>
    )

}